/*
=========================================================
* Senthil Solar React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import residential_1 from "assets/images/res_1.jpeg";
import residential_2 from "assets/images/res_2.jpeg";
import residential_3 from "assets/images/res_3.jpeg";
import residential_4 from "assets/images/res_4.jpeg";
import residential_5 from "assets/images/res_5.jpeg";
import residential_6 from "assets/images/res_6.jpeg";
import residential_7 from "assets/images/res_7.jpeg";
import residential_8 from "assets/images/res_8.jpeg";
import residential_9 from "assets/images/res_9.jpeg";
import residential_11 from "assets/images/res_11.jpeg";
import residential_12 from "assets/images/res_12.jpeg";
import residential_13 from "assets/images/res_13.jpeg";
import residential_14 from "assets/images/res_14.jpeg";
import residential_15 from "assets/images/res_15.jpeg";
import residential_16 from "assets/images/res_16.jpeg";
import residential_17 from "assets/images/res_17.jpeg";
import residential_18 from "assets/images/res_18.jpeg";
import residential_19 from "assets/images/res_19.jpeg";
import residential_20 from "assets/images/res_20.jpeg";
import residential_21 from "assets/images/res_21.jpeg";
import residential_22 from "assets/images/res_22.jpeg";
import residential_23 from "assets/images/res_23.jpeg";
import residential_24 from "assets/images/res_24.jpeg";
import residential_25 from "assets/images/res_25.jpeg";
import residential_26 from "assets/images/res_26.jpeg";
import residential_27 from "assets/images/res_27.jpeg";
import residential_28 from "assets/images/res_28.jpeg";
import residential_29 from "assets/images/res_29.jpeg";
import residential_30 from "assets/images/res_30.jpeg";
import residential_31 from "assets/images/res_31.jpeg";
import residential_32 from "assets/images/res_32.jpeg";
import residential_33 from "assets/images/res_33.jpeg";
import residential_34 from "assets/images/res_34.jpeg";
import residential_35 from "assets/images/res_35.jpeg";

import commercial_1 from "assets/images/1_comm.jpeg";
import commercial_2 from "assets/images/2_comm.jpg";
import commercial_3 from "assets/images/3_comm.jpeg";
import commercial_4 from "assets/images/4_comm.jpeg";
import commercial_5 from "assets/images/5_comm.jpeg";
import commercial_6 from "assets/images/6_comm.jpg";
import commercial_7 from "assets/images/7_comm.jpeg";
import commercial_8 from "assets/images/8_comm.jpeg";
import commercial_9 from "assets/images/9_comm.jpeg";
import commercial_10 from "assets/images/10_comm.jpeg";
import commercial_11 from "assets/images/11_comm.jpeg";
import commercial_12 from "assets/images/12_comm.jpeg";
import commercial_13 from "assets/images/13_comm.jpeg";
import commercial_14 from "assets/images/14_comm.jpeg";
import commercial_15 from "assets/images/15_comm.jpeg";
import commercial_16 from "assets/images/16_comm.jpeg";
import commercial_17 from "assets/images/17_comm.jpeg";
import commercial_18 from "assets/images/18_comm.jpeg";
import commercial_19 from "assets/images/19_comm.jpeg";
import commercial_20 from "assets/images/20_comm.jpeg";
import commercial_21 from "assets/images/21_comm.jpeg";
import commercial_22 from "assets/images/22_comm.jpeg";
import commercial_23 from "assets/images/23_comm.jpeg";
import commercial_24 from "assets/images/24_comm.jpeg";
import commercial_25 from "assets/images/25_comm.jpeg";
import commercial_26 from "assets/images/26_comm.jpeg";
import commercial_27 from "assets/images/27_comm.jpeg";
import commercial_28 from "assets/images/28_comm.jpeg";
import commercial_29 from "assets/images/29_comm.jpeg";
import commercial_30 from "assets/images/30_comm.jpeg";
import commercial_31 from "assets/images/31_comm.jpeg";
import commercial_32 from "assets/images/32_comm.jpeg";
import commercial_33 from "assets/images/33_comm.jpeg";
import commercial_34 from "assets/images/34_comm.jpeg";
import commercial_35 from "assets/images/35_comm.jpeg";
import commercial_36 from "assets/images/36_comm.jpeg";
import commercial_37 from "assets/images/37_comm.jpeg";
import commercial_38 from "assets/images/38_comm.jpeg";
import commercial_39 from "assets/images/39_comm.jpeg";
import commercial_40 from "assets/images/40_comm.jpeg";
import commercial_41 from "assets/images/41_comm.jpeg";
import commercial_42 from "assets/images/42_comm.jpeg";
import commercial_43 from "assets/images/43_comm.jpeg";
import commercial_44 from "assets/images/44__comm.jpeg";
import commercial_45 from "assets/images/45_comm.jpeg";
import commercial_46 from "assets/images/46_comm.jpeg";
import commercial_47 from "assets/images/46_comm.jpeg";

import off_grid_1 from "assets/images/off_grid_1.jpeg";
import off_grid_2 from "assets/images/off_grid_2.jpeg";
import off_grid_3 from "assets/images/off_grid_3.jpeg";
import off_grid_4 from "assets/images/off_grid_4.jpeg";
import off_grid_5 from "assets/images/off_grid_5.jpeg";
import off_grid_6 from "assets/images/off_grid_6.jpeg";

import solar_pump_1 from "assets/images/solarpump_1.jpeg";
import solar_pump_2 from "assets/images/solarpump_2.jpeg";
import solar_pump_3 from "assets/images/solarpump_3.jpeg";
import solar_pump_4 from "assets/images/solarpump_4.jpeg";
import solar_pump_5 from "assets/images/solarpump_5.jpeg";
import solar_pump_6 from "assets/images/solarpump_6.jpeg";
import solar_pump_7 from "assets/images/solarpump_7.jpeg";
import solar_pump_8 from "assets/images/solarpump_8.jpeg";
import solar_pump_9 from "assets/images/solarpump_9.jpeg";
import solar_pump_10 from "assets/images/solarpump_10.jpeg";
import solar_pump_11 from "assets/images/solarpump_11.jpeg";
import solar_pump_12 from "assets/images/solarpump_12.jpeg";
import solar_pump_13 from "assets/images/solarpump_13.jpeg";
import solar_pump_14 from "assets/images/solarpump_14.jpeg";
import solar_pump_15 from "assets/images/solarpump_15.jpeg";
import solar_pump_17 from "assets/images/solarpump_17.jpeg";
import solar_pump_18 from "assets/images/solarpump_18.jpeg";
import solar_pump_19 from "assets/images/solarpump_18.jpeg";


// Data for different solar solution categories
export default [
  {
    category: 'Residential',
    items: [
      { image: residential_1 },
      { image: residential_2 },
      { image: residential_3 },
      { image: residential_4 },
      { image: residential_7 },
      { image: residential_5 },
      { image: residential_9 },
      { image: residential_11 },
      { image: residential_12 },
      { image: residential_13 },
      { image: residential_14 },
      { image: residential_15 },
      { image: residential_16 },
      { image: residential_17 },
      { image: residential_18 },
      { image: residential_19 },
      { image: residential_20 },
      { image: residential_21 },
      { image: residential_22 },
      { image: residential_23 },
      { image: residential_24},
      { image: residential_25 },
      { image: residential_26 },
      { image: residential_27 },
      { image: residential_28 },
      { image: residential_29 },
      { image: residential_30 },
      { image: residential_31 },
      { image: residential_32 },
      { image: residential_33 },
      { image: residential_34 },
      { image: residential_35 },
    ],
  },
  {
    category: 'Commercial',
    items: [
      { image: commercial_1 },
      { image: commercial_2 },
      { image: commercial_3 },
      { image: commercial_4 },
      { image: commercial_5 },
      { image: commercial_6 },
      { image: commercial_7 },
      { image: commercial_8 },
      { image: commercial_9 },
      { image: commercial_10 },
      { image: commercial_11 },
      { image: commercial_12 },
      { image: commercial_13 },
      { image: commercial_14 },
      { image: commercial_15 },
      { image: commercial_16 },
      { image: commercial_17 },
      { image: commercial_18 },
      { image: commercial_19 },
      { image: commercial_20 },
      { image: commercial_21 },
      { image: commercial_22 },
      { image: commercial_23 },
      { image: commercial_24 },
      { image: commercial_25 },
      { image: commercial_26 },
      { image: commercial_27 },
      { image: commercial_28 },
      { image: commercial_29 },
      { image: commercial_30 },
      { image: commercial_31 },
      { image: commercial_32 },
      { image: commercial_33 },
      { image: commercial_34 },
      { image: commercial_35 },
      { image: commercial_36 },
      { image: commercial_37 },
      { image: commercial_38 },
      { image: commercial_39 },
      { image: commercial_40 },
      { image: commercial_41 },
      { image: commercial_42 },
      { image: commercial_43 },
      { image: commercial_44 },
      { image: commercial_45 },
      { image: commercial_46 },
      { image: commercial_47 },
    ],
  },
  // {
  //   category: 'Solar Lights',
  //   items: [
  //     { image: solar_light_1 },
  //     { image: solar_light_2 },
  //   ],
  // },
  {
    category: 'Off-Grid',
    items: [
      { image: off_grid_1 },
      { image: off_grid_2 },
      { image: off_grid_3 },
      { image: off_grid_4 },
      { image: off_grid_5 },
      { image: off_grid_6 },
    ],
  },
  {
    category: 'Solar Heaters',
    items: [
      { image: solar_pump_13 },
      { image: solar_pump_14 },
      { image: solar_pump_15 },
      { image: solar_pump_17 },
      { image: solar_pump_18 },
      { image: solar_pump_19 },
      { image: residential_6 },
      { image: residential_8 },
      { image: solar_pump_12 },
    ],
  },
  {
    category: 'Solar Pump',
    items: [
      { image: solar_pump_1 },
      { image: solar_pump_2 },
      { image: solar_pump_3 },
      { image: solar_pump_4 },
      { image: solar_pump_5 },
      { image: solar_pump_6 },
      { image: solar_pump_7 },
      { image: solar_pump_8 },
      { image: solar_pump_9 },
      { image: solar_pump_10 },
      { image: solar_pump_11 },
    ],
  },
];
